module.exports = __webpack_public_path__ + "static/media/chevron_down_blue.f648275c.svg";


//////////////////
// WEBPACK FOOTER
// ./src/spread/chartOfAccounts/chevron_down_blue.svg
// module id = 2200
// module chunks = 0